import { Component, ElementRef, ViewChild } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  ValidatorFn,
  AbstractControl,
  FormArray,
} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ToasterMessages } from 'src/app/shared/constants/constants';
import { getSegmentOptions, getVoyageFormSegmentOptions } from 'src/app/shared/helpers/Drop-down-options';
import { PortRequestFormServiceService } from 'src/app/shared/service/port-request-FormService/port-request-form.service.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';
import { SisterShipPopupComponent } from './pages/sister-ship-popup/sister-ship-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { PortsPopupComponent } from '../../request-form/pages/ports-popup/ports-popup.component';
import { ReportVerifyPopupComponent } from 'src/app/shared/components/report-verify-popup/report-verify-popup.component';
import { ClientPopupComponent } from '../../onboarding-form/client-popup/client-popup.component';
import { RetriveReportsFetchComponent } from 'src/app/shared/components/retrive-reports-fetch/retrive-reports-fetch.component';
import { UploadfileValidationComponent } from 'src/app/shared/components/uploadfile-validation/uploadfile-validation.component';
import { OptimizationPopupComponent } from './pages/optimization-popup/optimization-popup.component';
import { CheckcospSubmitformComponent } from '../checkcosp-submitform/checkcosp-submitform.component';
import { DocumentVerificationPopupComponent } from './pages/document-verification-popup/document-verification-popup.component';

@Component({
  selector: 'app-port-request-form',
  templateUrl: './port-request-form.component.html',
  styleUrls: ['./port-request-form.component.scss'],
})
export class PortRequestFormComponent {
  requestForm!: FormGroup;
  formSubmitted: boolean = false;
  clientOptions: any;
// Store full parsed JSON objects in memory for preview
savedSofParsedData: any = null;
savedPumpingLogParsedData: any = null;
  anyotherOperations = ['Heating', 'Inerting', 'Tank Cleaning'];
  typeofOperations = ['Loading', 'Discharging'];
  statusOptions = ['Maneuvering', 'Idle'];
  dischargingSystem = ['Framo', 'Cop', 'MARFLEX'];
  portNameSuggestions: any[] = [];
  filteredPortNames: any[] = [];
  shipyardOptions = ['TBD'];
  typeofshipOptions = [
    'Bulk Carrier',
    'Chem Tanker',
    'Container',
    'General CArgo',
    'Oil Tanker',
    'Tanker',
  ];
  merakiPicOptions = [
  { label: 'AAY - Aayush Singh Parmar', value: 'AAY' },
  { label: 'AMA - Amrit Anand', value: 'AMA' },
  { label: 'ANKU - Usha Kumari', value: 'ANKU' },
  { label: 'AJK - Ajeet Kumar', value: 'AJK' },
  { label: 'DEB - Deepika Bhardwaj', value: 'DEB' },
  { label: 'GMK - Gaurav Mohan Kulkarni', value: 'GMK' },
  { label: 'GUS - Gurvinder Singh', value: 'GUS' },
  { label: 'HAS - Harshi Jain', value: 'HAS' },
  { label: 'KER - Keerthana Rajamani', value: 'KER' },
  { label: 'KPJ - Kinshuk Pragya Jha', value: 'KPJ' },
  { label: 'MAL - Malini Sivaranjini', value: 'MAL' },
  { label: 'MNG - Manisha Ganesh', value: 'MNG' },
  { label: 'NAB - Nancy Baidya', value: 'NAB' },
  { label: 'PHJ - Philomina Johnthomas', value: 'PHJ' },
  { label: 'STP - Shatakshi Priya', value: 'STP' },
  { label: 'SNK - Sonu Kumar', value: 'SNK' },
  { label: 'SOS - Souta Samanta', value: 'SOS' },
  { label: 'SUTH - Suman Saurav Thakur', value: 'SUTH' },
];
  // merakiPicOptions = [
  //   { label: 'ALS - Alexroger', value: 'ALS' },
  //   { label: 'HAJ - Hancy', value: 'HAJ' },
  //   { label: 'HAS - Harshi', value: 'HAS' },
  //   { label: 'KER - Keerthana', value: 'KER' },
  //   { label: 'INV - Indhirani', value: 'INV' },
  //   { label: 'MAL - Malini', value: 'MAL' },
  //   { label: 'PHJ - Philomina', value: 'PHJ' },
  //   { label: 'PRA - Priya', value: 'PRA' },
  //   { label: 'RAS - Rajeswari', value: 'RAS' },
  //   { label: 'SAG - Santhosh', value: 'SAG' },
  //   { label: 'SOS - Souta Samanta ', value: 'SOS' },
  //   { label: 'BHY - Bhargavi', value: 'BHY' },
  //   { label: 'NAB - Nancy', value: 'NAB' },
  //   { label: 'DEKA - Deepika', value: 'DEKA' },
  //   { label: 'ARYA - Arbaaz', value: 'ARYA' },
  //   { label: 'HRIT - Hritik', value: 'HRIT' },
  //   { label: 'NIMA- Niharika Mahajan', value: 'NIMA' },
  //   { label: 'TST - Test', value: 'TST' },
  //   { label: 'ANKU ', value: 'ANKU ' },
  //   { label: 'SUTH', value: 'SUTH' },
  //   { label: 'Sowmya', value: 'SOKU' },
  //   { label: 'Manisha', value: 'MAGA' },
  //    { label: 'Jeevan', value: 'Jeev' },
  // ];
  weatherSourceOptions = [
    { label: 'DTN', value: 'DTN' },
    { label: 'Storm Glass', value: 'stormglass' },
  ];
  eigerPicOptions = [
    { label: 'SAKA - Satish', value: 'SAKA' },
    { label: 'SABA - Sandokan', value: 'SABA' },
    { label: 'ROAK - Roman', value: 'ROAK' },
    { label: 'AAHA - Ahmet', value: 'AAHA' },
    { label: 'NIAL - Nikita', value: 'NIAL' },
    // { label: 'JESH - Jeet', value: 'JESH' },
    { label: 'RAPA - Rahul', value: 'RAPA' },
    { label: 'AHKM - Abhishek', value: 'AHKM' },
    { label: 'SAMH - Sadique Muhammad', value: 'SAMH' },
    { label: 'ALYI - Alex', value: 'ALYI' },
  ];
  segmentOptions: any = getVoyageFormSegmentOptions();
  typeOfSpeedOptions = [
    { label: 'Constant Speed', value: 'CP Speed' },
    {
      label: 'Optimal Speed(Reefer container)',
      value: 'Optimal Speed(Reefer container)',
    },
    { label: 'Optimal Speed', value: 'Optimal Speed' },
  ];
  voyageTypeOptions = [
    { label: 'Laden', value: 'Laden' },
    { label: 'Ballast', value: 'Ballast' },
  ];
  reportTypeOptions = [
    { label: 'Transit', value: 'Transit' },
    { label: 'Berth', value: 'Port' },
  ];
  yesNo = [
    { label: 'Yes', value: 'YES' },
    { label: 'No', value: 'NO' },
  ];
  weatherfactorOptions = [
    { label: 'Yes', value: 'YES' },
    { label: 'No', value: 'NO' },
  ];
  yesNoDayPositive = [
    { label: 'Yes', value: 'all_day_positive' },
    { label: 'No', value: 'no' },
  ];
  duelFuelOptions = [
    { label: 'Yes', value: 'excluded' },
    { label: 'No', value: 'included' },
  ];
  adverseCurrentValue = [
    { label: 'Yes', value: 'x' },
    { label: 'No', value: 'inc' },
  ];
  yesNo3 = [
    { label: 'Yes', value: 'YES' },
    { label: 'No', value: 'NO' },
    { label: 'N/A', value: 'Not Applicable' },
  ];
  wetherCalculationOptions = [
    { label: 'BF Only', value: 'BF' },
    { label: 'DSS', value: 'DSS' },
    { label: 'SWH', value: 'SWH' },
    { label: 'SWH&DSS', value: 'SWH+DSS' },
    { label: 'Wind Wave & Swell Height', value: 'Wind Wave & Swell Height' },
  ];

  performanceCalOptions = [
    { label: 'Voyage', value: 'Voyage' },
    { label: 'Daily', value: 'Daily' },
  ];
  templetOptions = [
    { label: 'Weather Report', value: 'weather_report' },
    // { label: 'Ballast', value: 'Ballast' },
  ];
  goodWeatherPeriod = [12, 15, 18, 24];
  windBeaufort = [2, 3, 4, 5, 6];
  fuelType = ['ULSFO', 'VLSFO', 'HSFO', 'MDO', 'LNG', 'OTHERS', 'NA'];
  bunkerGradeOptions1: string[] = ['HSFO', 'VLSFO', 'MGO', 'LNG', 'ULSFO']; // example grades
  bunkerGradeOptions2: string[] = ['HSFO', 'VLSFO', 'MGO', 'LNG', 'ULSFO'];
  bunkerGradeOptions3: string[] = ['HSFO', 'VLSFO', 'MGO', 'LNG', 'ULSFO'];
  fromOptions: string[] = [
    'Singapore Transit',
    'Dardanelles',
    'Bosporus',
    'Turkish Strait',
    'Suez Canal',
    'Panama Canal',
    'Danish Strait',
  ];
  selectedFile!: File;
  selectedMainCPFile!: File;
  @ViewChild('fileInput') fileInput: ElementRef | undefined;
  @ViewChild('fileUpload') fileUpload: ElementRef | undefined;
  datesValidator: boolean = false;
  latDir = ['N', 'S'];
  longDir = ['E', 'W'];
  id: any;
  reportGenerate: boolean = false;
  mainCpFile: boolean = false;
  dataToPass: any;
  selectedRequestformFile: any;
  previousValue: any;
  weatherFactor: boolean = false;
  bunkerOperationIsYes: boolean = true;
  fileId: any;

  isUpload: boolean = false;
  @ViewChild('requestformFileInput')
  requestformFileInput!: ElementRef<HTMLInputElement>;
  PortRequestFormServiceService: any;
  portDetails: any;
  @ViewChild('sofFileInput') sofFileInput!: ElementRef<HTMLInputElement>;
@ViewChild('pumpingLogFileInput') pumpingLogFileInput!: ElementRef<HTMLInputElement>;
  selectedSofFile: File | null = null;
sofFileName: string = '';
sofFileError: string = '';

selectedPumpingLogFile: File | null = null;
pumpingLogFileName: string = '';
pumpingLogFileError: string = '';

readonly ALLOWED_FILE_TYPES = [
  'application/pdf',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'image/jpeg',
  'image/png',
  'image/jpg'
];
readonly MAX_FILE_SIZE_MB = 10;

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private requestFormService: RequestFormService,
    private pRequestFormService: PortRequestFormServiceService,
    private dialog: MatDialog,
  ) {
    this.requestForm = this.fb.group({
      merakiPic: ['', Validators.required],
      clientPic: [''],
      vesselName: ['', Validators.required],
      imoNumber: ['', Validators.required],
      voyNumber: [''],
      segment: [''],
      shipYard: [''],
      Yearbuilt: [''],
      typeOfShip: [''],
      portName: ['', Validators.required],
      pfrom: [{ value: '', disabled: true }, Validators.required],
      pto: [''],
      reportType: ['', Validators.required],
      // eca: [''],
      fuelType: ['', Validators.required],
      fuelTypeOne: ['', Validators.required],
      fuelTypeTwo: ['', Validators.required],
      vesselFitted: [''],
      bunkerOperataion: [''],
      sofFile: [null],
      // Pumping Log Fields
      pumpingLogFile: [null],
      quaBunkerGradeOne: [''],
      quantityOne: [''],
      quaBunkerGradeTwo: [''],
      quantityTwo: [''],
      quaBunkerGradeThree: [''],
      quantityThree: [''],
      disBunkerGradeOne: [''],
      disNumericValueOne: [''],
      disBunkerGradeTwo: [''],
      disNumericValueTwo: [''],
      disBunkerGradeThree: [''],
      disNumericValueThree: [''],
      otherOperations: this.fb.array([this.createOperationGroup()]),
      ecaRegion: [''],
      cosp: [''],
      cospHours: [''],
      cospMinutes: [''],
      eosp: [''],
      eospHours: [''],
      eospMinutes: [''],
      client: ['', Validators.required],
      typeOfOperations: ['', Validators.required],
      cargoQuantity: [''],
      pumpRPM: ['', Validators.required],
      no_of_pump: [''],
      ae_tcp: [''],
      fuelMinTol: ['', Validators.required],
      reportedDate: ['', Validators.required],
      reportedHours: [''],
      reportedMinutes: [''],
      additionalComments: [''],
      file_id: [''],
    });
    
  }

  ngOnInit(): void {
    this.loadClientOptions();
    this.requestForm.get('reportType')?.valueChanges.subscribe((val) => {
      if (val === 'Transit') {
        this.requestForm.get('pfrom')?.enable();
      } else {
        this.requestForm.get('pfrom')?.disable();
        this.requestForm.get('pfrom')?.setValue('');
      }
    });
    this.pRequestFormService.getPortDetails().subscribe({
      next: (response: any) => {
        // Use 'ports' array from API response
        this.filteredPortNames = response?.ports ?? [];
        console.log('Filtered Port Names:', this.filteredPortNames);
      },
      error: (err: any) => {
        console.error('Error fetching port list:', err);
      },
    });
    this.requestForm
      .get('bunkerOperataion')
      ?.valueChanges.subscribe((value: string) => {
        this.bunkerOperationIsYes = value === 'Yes';
      });
  }
  openUploadPopup() {
    const dialogRef = this.dialog.open(UploadfileValidationComponent, {
      width: '900px',
      maxWidth: '100vw',
      disableClose: true,
      panelClass: 'upload-dialog-container',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        console.log('Upload completed');
      }
    });
  }
  openRetrievePopup(): void {
    const dialogRef = this.dialog.open(RetriveReportsFetchComponent, {
      width: '900px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        console.log('Retrieve popup result:', result);
      }
    });
  }
  loadClientOptions() {
    this.requestFormService.getClientList().subscribe({
      next: (res: any[]) => {
        this.clientOptions = res.map((client) => client.client_name);
      },
      error: (err) => console.error('Client API error', err),
    });
  }
  filterPortNames(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();

    if (this.filteredPortNames && event) {
      this.portNameSuggestions = this.filteredPortNames
        .map((p) => (Array.isArray(p.port_name) ? p.port_name[0] : ''))
        .filter((name) => name.toLowerCase().startsWith(filterValue));
    } else {
      this.portNameSuggestions = [];
    }

    console.log('Suggestions:', this.portNameSuggestions);
  }

  onPortSelected(selectedPortName: string) {
    this.requestForm.get('pfrom')?.setValue(selectedPortName);

    const selected = this.filteredPortNames.find(
      (p) => Array.isArray(p.port_name) && p.port_name[0] === selectedPortName,
    );

    if (selected) {
      this.requestForm.get('pto')?.setValue(selected.region || '');
      this.requestForm.get('pfrom')?.setValue(selected.code || '');
    }

    this.portNameSuggestions = [];
  }

  get otherOperations(): FormArray {
    return this.requestForm.get('otherOperations') as FormArray;
  }
  createOperationGroup(): FormGroup {
    return this.fb.group({
      anyOtherOperations: [''],
      operationHours: [0],
      status: [''],
    });
  }

  addRow() {
    if (this.otherOperations.length < 3) {
      this.otherOperations.push(this.createOperationGroup());
    }
  }

  removeRow(index: number) {
    this.otherOperations.removeAt(index);
  }
  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }
  onInputChange(event: Event, controlName: string) {
    const inputElement = event.target as HTMLInputElement;
    const currentValue = inputElement.value;
    if (currentValue.length > 30) {
      inputElement.value = currentValue.slice(0, 30);
    }
    this.requestForm.get(controlName)?.setValue(inputElement.value);
  }
  onVoyageChange(event: Event, controlName: string) {
    const inputElement = event.target as HTMLInputElement;
    const currentValue = inputElement.value;
    if (currentValue.length > 10) {
      inputElement.value = currentValue.slice(0, 10);
    }
    this.requestForm.get(controlName)?.setValue(inputElement.value);
  }
  onInput(event: Event, controlName: string) {
    const inputElement = event.target as HTMLInputElement;
    let currentValue = inputElement.value;
    const numericValue = currentValue.replace(/[^0-9.]/g, '');
    const maxLength = 4;
    if (numericValue.length > maxLength) {
      inputElement.value = numericValue.slice(0, maxLength);
    } else {
      inputElement.value = numericValue;
    }
    this.requestForm.get(controlName)?.setValue(inputElement.value);
  }
  numberInput(event: Event, controlName: string) {
    const inputElement = event.target as HTMLInputElement;
    let currentValue = inputElement.value;
    const numericValue = currentValue.replace(/[^0-9.]/g, '');
    inputElement.value = numericValue;
    this.requestForm.get(controlName)?.setValue(inputElement.value);
  }
  defaultFormValues = {
    merakiPic: '',
    clientPic: '',
    vesselName: '',
    imoNumber: '',
    voyNumber: '',
    segment: '',
    shipYard: '',
    Yearbuilt: '',
    typeOfShip: '',
    portName: '',
    pfrom: '',
    pto: '',
    reportType: '',
    fuelType: '',
    fuelTypeOne: '',
    fuelTypeTwo: '',
    vesselFitted: '',
    bunkerOperataion: '',
  sofFile: null,
  pumpingLogFile: null,
    quaBunkerGradeOne: '',
    quantityOne: '',
    quaBunkerGradeTwo: '',
    quantityTwo: '',
    quaBunkerGradeThree: '',
    quantityThree: '',
    disBunkerGradeOne: '',
    disNumericValueOne: '',
    disBunkerGradeTwo: '',
    disNumericValueTwo: '',
    disBunkerGradeThree: '',
    disNumericValueThree: '',
    otherOperations: [this.createOperationGroup()],
    // cosp: '',
    // cospHours: '',
    // cospMinutes: '',
    // eosp: '',
    // eospHours: '',
    // eospMinutes: '',
    client: '',
    typeOfOperations: '',
    cargoQuantity: '',
    pumpRPM: '',
    fuelMinTol: '',
    reportedDate: '',
    reportedHours: '',
    reportedMinutes: '',
    additionalComments: '',
    file_id: '',
  };
  clearClick() {
    this.requestForm.get('cosp')?.clearValidators();
    this.requestForm.get('cospHours')?.clearValidators();
    this.requestForm.get('cospMinutes')?.clearValidators();
    this.requestForm.get('eosp')?.clearValidators();
    this.requestForm.get('eospHours')?.clearValidators();
    this.requestForm.get('eospMinutes')?.clearValidators();
    this.removeSofFile();
  this.removePumpingLogFile();
    this.requestForm.reset(this.defaultFormValues);
    this.requestForm.setControl(
      'otherOperations',
      this.fb.array([this.createOperationGroup()]),
    );
    this.formSubmitted = false;
    this.isUpload = false;
    this.selectedRequestformFile = null;
    if (this.requestformFileInput) {
      this.requestformFileInput.nativeElement.value = '';
    }
  }
submitClick() {
  const numericFields = [
    'cargoQuantity',
    'quantityOne',
    'quantityTwo',
    'quantityThree',
    'disNumericValueOne',
    'disNumericValueTwo',
    'disNumericValueThree',
    'pumpRPM',
    'fuelMinTol',
    'operationHours',
  ];

  this.normalizeNumberFields(numericFields);

  if (this.requestForm.get('reportType')?.value === 'Transit') {
    this.requestForm.get('pfrom')?.setValue(
      this.requestForm.get('portName')?.value
    );
    this.requestForm.get('portName')?.setValue('');
  }

  const json = {
    ...this.requestForm.value
  };

  this.pRequestFormService.PostRequestForm(json).subscribe(
    (data) => {
      this.toastr.success(ToasterMessages.SubmitForm);
      this.clearClick();
    },
    (error) => {
      this.toastr.error(ToasterMessages.Error);
    }
  );
}
  finalSubmit(version: string) {

  const numericFields = [
    'cargoQuantity',
    'quantityOne',
    'quantityTwo',
    'quantityThree',
    'disNumericValueOne',
    'disNumericValueTwo',
    'disNumericValueThree',
    'pumpRPM',
    'fuelMinTol',
    'operationHours',
  ];

  this.normalizeNumberFields(numericFields);

  if (this.requestForm.get('reportType')?.value === 'Transit') {
    this.requestForm.get('pfrom')?.setValue(this.requestForm.get('portName')?.value);
    this.requestForm.get('portName')?.setValue('');
  }

  const json = {
    ...this.requestForm.value,
    version: version   // 👈 important (popup se aaya)
  };

  this.pRequestFormService.PostRequestForm(json).subscribe(
    (data) => {
      this.toastr.success(ToasterMessages.SubmitForm);
      this.clearClick();
    },
    (error) => {
      this.toastr.error(ToasterMessages.Error);
    }
  );

}
  normalizeNumberFields(fields: string[]) {
    fields.forEach((field) => {
      const control = this.requestForm.get(field);
      if (control && (control.value === null || control.value === '')) {
        control.setValue(0);
      }
    });
  }

  topClick() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  restrictInput(inputField: any, maxAllowed: any) {
    inputField.value = inputField.value.replace(/^0+/, '');
    if (parseInt(inputField.value) > maxAllowed) {
      inputField.value = maxAllowed;
    }
    if (inputField.value === '0' || inputField.value === '') {
      inputField.value = '00';
    }
    if (inputField.value.length === 1) {
      inputField.value = '0' + inputField.value;
    }
  }

  validateHours(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = parseFloat(input.value);

    if (isNaN(value)) return;

    if (value < 0) {
      input.value = '0';
    }
  }

  maxWordsValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value: string = control.value || '';
      const words: string[] = value.trim().split(/\s+/);
      if (words.length > 1500) {
        return { maxWordsExceeded: true };
      }
      return null;
    };
  }

  onRequestformFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input?.files?.length) {
      this.selectedRequestformFile = input.files[0];
      console.log('Uploaded File Name:');
    }
    this.pRequestFormService.uploadFile(this.selectedRequestformFile).subscribe(
      (data) => {
           this.requestForm.patchValue(data);
        this.fileId = data.file_id;
        this.isUpload = true;
        if (data.segment) {
          const matchedSegment = this.segmentOptions.find(
            (option: any) =>
              option.toLowerCase() === data.segment.toLowerCase(),
          );

          data.segment = matchedSegment || null; // set properly formatted value
        }
     
      },
      (error) => {
        this.toastr.warning(ToasterMessages.fileFormat);
      },
    );
  }
  setETA(etaString: string) {
    if (!etaString) return;

    // Remove 'LT' and split date & time parts
    const [datePart, timePart] = etaString.replace(' LT', '').split(' ');

    // Month mapping
    const months: { [key: string]: string } = {
      JAN: '01',
      FEB: '02',
      MAR: '03',
      APR: '04',
      MAY: '05',
      JUN: '06',
      JUL: '07',
      AUG: '08',
      SEP: '09',
      OCT: '10',
      NOV: '11',
      DEC: '12',
    };

    // Convert date format from "DD-MMM-YY" to "YYYY-MM-DD"
    const [day, monthAbbr, year] = datePart.split('-');
    const formattedDate = `20${year}-${months[monthAbbr]}-${day}`;

    // Extract hours and minutes
    const [hours, minutes] = timePart.split(':');

    // Set values to form fields
    this.requestForm.get('etaDate')?.setValue(formattedDate);
    this.requestForm.get('etaHours')?.setValue(hours);
    this.requestForm.get('etaMinutes')?.setValue(minutes);
  }
  convertLatLong(latStr: string, longStr: string) {
    let lat, latDir, long, longDir;

    // Ensure latStr and longStr are treated as strings
    const latString = latStr.toString();
    const longString = longStr.toString();

    // Convert Latitude
    if (latString.includes('N') || latString.includes('S')) {
      latDir = latString.includes('N') ? 'N' : 'S';
      lat = parseFloat(latString.replace(/[^\d.-]/g, '')); // Remove non-numeric characters and convert to float
      if (latDir === 'S') lat = -lat; // Convert to negative if South
    } else {
      lat = parseFloat(latString);
      latDir = lat >= 0 ? 'N' : 'S'; // Determine direction based on sign
      lat = Math.abs(lat); // Store absolute value in form
    }

    // Convert Longitude
    if (longString.includes('E') || longString.includes('W')) {
      longDir = longString.includes('E') ? 'E' : 'W';
      long = parseFloat(longString.replace(/[^\d.-]/g, '')); // Remove non-numeric characters and convert to float
      if (longDir === 'W') long = -long; // Convert to negative if West
    } else {
      long = parseFloat(longString);
      longDir = long >= 0 ? 'E' : 'W'; // Determine direction based on sign
      long = Math.abs(long); // Store absolute value in form
    }

    // Populate form fields
    this.requestForm.get('currLat')?.setValue(lat);
    this.requestForm.get('latDir')?.setValue(latDir);
    this.requestForm.get('currLng')?.setValue(long);
    this.requestForm.get('longDir')?.setValue(longDir);
  }
  addClick() {
    const dialog = this.dialog.open(PortsPopupComponent, {
      width: '600px',
      height: '400px',
      disableClose: true,
    });
    dialog.afterClosed().subscribe((result) => {
      this.portDetails.getPortDetails().subscribe((response: any) => {
        this.filteredPortNames = response?.data ?? [];
      });
    });
  }
  viewReport(): void {
    const dialogRef = this.dialog.open(ReportVerifyPopupComponent, {
      width: '900px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log('Popup closed. Result:', result);
      // Optional: refresh or take action based on popup result
    });
  }
  sisterShipClick() {
    const dialogRef = this.dialog.open(SisterShipPopupComponent, {
      width: '500px',
      height: '300px',
      disableClose: true,
    });

    dialogRef
      .afterClosed()
      .subscribe((result: { vesselName: any; vesselIMO: any }) => {
        if (result) {
          console.log('Received Vessel Data:', result);
          // Use the data in this component as needed
        }
      });
  }

  addClientClick() {
    const dialog = this.dialog.open(ClientPopupComponent, {
      width: '600px',
      height: '400px',
      disableClose: true,
    });
    dialog.afterClosed().subscribe((result) => {
      // call API to get Client names
    });
  }
  optimizationClick() {
    const dialog = this.dialog.open(OptimizationPopupComponent, {
      width: '670px',
      height: '470px',
      disableClose: true,
      autoFocus: false,
    });
  }
  // SOF Selection & Parsing
onSofFileSelected(event: Event): void {
  const input = event.target as HTMLInputElement;
  if (!input.files || input.files.length === 0) return;

  const file = input.files[0];
  const validationError = this.validateFile(file);
  if (validationError) {
    this.sofFileError = validationError;
    this.removeSofFile(input);
    this.toastr.warning(validationError);
    return;
  }

  this.sofFileError = '';
  this.selectedSofFile = file;
  this.sofFileName = file.name;

  this.toastr.info('Extracting Statement of Facts data with AI...', 'Please Wait');

  this.pRequestFormService.uploadAndParseDocument(file, 'SOF').subscribe({
    next: (res: any) => {
      if (res?.success && res?.file_id) {
        this.requestForm.patchValue({ sofFile: res.file_id });
        
        // Cache the parsed JSON response in the component state
        this.savedSofParsedData = res;

        this.toastr.success('SOF data extracted successfully!');
        this.openVerificationPopup(res, 'SOF');
      } else {
        this.toastr.error(res?.error || 'Failed to extract SOF data');
      }
    },
    error: (err: any) => {
      console.error('SOF Parsing Error:', err);
      this.toastr.error('Failed to parse SOF document with AI');
    }
  });
}

// Pumping Log Selection & Parsing
onPumpingLogFileSelected(event: Event): void {
  const input = event.target as HTMLInputElement;
  if (!input.files || input.files.length === 0) return;

  const file = input.files[0];
  const validationError = this.validateFile(file);
  if (validationError) {
    this.pumpingLogFileError = validationError;
    this.removePumpingLogFile(input);
    this.toastr.warning(validationError);
    return;
  }

  this.pumpingLogFileError = '';
  this.selectedPumpingLogFile = file;
  this.pumpingLogFileName = file.name;

  this.toastr.info('Extracting Pumping Log data with AI...', 'Please Wait');

  this.pRequestFormService.uploadAndParseDocument(file, 'PUMPING_LOG').subscribe({
    next: (res: any) => {
      if (res?.success && res?.file_id) {
        this.requestForm.patchValue({ pumpingLogFile: res.file_id });

        // Cache the parsed JSON response in the component state
        this.savedPumpingLogParsedData = res;

        this.toastr.success('Pumping Log data extracted successfully!');
        this.openVerificationPopup(res, 'PUMPING_LOG');
      } else {
        this.toastr.error(res?.error || 'Failed to extract Pumping Log data');
      }
    },
    error: (err: any) => {
      console.error('Pumping Log Parsing Error:', err);
      this.toastr.error('Failed to parse Pumping Log document with AI');
    }
  });
}

  // =========================================================================
  // OPEN VERIFICATION POPUP (MODAL HANDLER)
  // =========================================================================
  openVerificationPopup(parsedResult: any, docType: 'SOF' | 'PUMPING_LOG'): void {
    const dialogRef = this.dialog.open(DocumentVerificationPopupComponent, {
      width: '1150px',
      maxWidth: '95vw',
      maxHeight: '90vh',
      disableClose: true,
      data: {
        ...parsedResult,
        doc_type: docType // Attaches explicit doc_type for the Save/Confirm API payload
      }
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.toastr.success(`${docType === 'SOF' ? 'SOF' : 'Pumping Log'} verified & attached to request!`);
      }
    });
  }
// Re-open verification modal directly using frontend cached data
reopenParsedDataModal(docType: 'SOF' | 'PUMPING_LOG'): void {
  const parsedData = docType === 'SOF' ? this.savedSofParsedData : this.savedPumpingLogParsedData;

  if (!parsedData) {
    this.toastr.warning(`No cached ${docType === 'SOF' ? 'SOF' : 'Pumping Log'} data available.`);
    return;
  }

  this.openVerificationPopup(parsedData, docType);
}
  removeSofFile(input?: HTMLInputElement): void {
  this.selectedSofFile = null;
  this.sofFileName = '';
  this.sofFileError = '';
  this.savedSofParsedData = null; // Clear cached JSON
  this.requestForm.patchValue({ sofFile: null });
  if (input) input.value = '';
  if (this.sofFileInput) this.sofFileInput.nativeElement.value = '';
}

removePumpingLogFile(input?: HTMLInputElement): void {
  this.selectedPumpingLogFile = null;
  this.pumpingLogFileName = '';
  this.pumpingLogFileError = '';
  this.savedPumpingLogParsedData = null; // Clear cached JSON
  this.requestForm.patchValue({ pumpingLogFile: null });
  if (input) input.value = '';
  if (this.pumpingLogFileInput) this.pumpingLogFileInput.nativeElement.value = '';
}

// Helper method for file validation (Size & Format)
validateFile(file: File): string | null {
  const ext = file.name.split('.').pop()?.toLowerCase();
  const allowedExtensions = ['pdf', 'xlsx', 'xls', 'doc', 'docx', 'png', 'jpg', 'jpeg'];

  if (!allowedExtensions.includes(ext || '') && !this.ALLOWED_FILE_TYPES.includes(file.type)) {
    return 'Invalid file format. Please upload PDF, Excel, Word, or Image files.';
  }

  const fileSizeMB = file.size / (1024 * 1024);
  if (fileSizeMB > this.MAX_FILE_SIZE_MB) {
    return `File size exceeds maximum limit of ${this.MAX_FILE_SIZE_MB}MB.`;
  }

  return null;
}
}
